import { useTranslation } from 'react-i18next'
import { getContrastTextColor, isLightColor } from '@structural-climbing/ui'
import { ROUTE_COLORS } from './constants'

interface HoldColorPickerProps {
  value: string
  onChange: (color: string) => void
}

/** The hold/tape colour swatches shared by the add and edit route forms. */
export function HoldColorPicker({ value, onChange }: HoldColorPickerProps) {
  const { t } = useTranslation()
  const selected = ROUTE_COLORS.find((c) => c.value === value)

  return (
    <div>
      <p className="mb-2 text-sm font-medium">
        {t('routes.color')}
        {selected && <span className="ml-2 font-normal text-foreground/50">{selected.label}</span>}
      </p>
      <div className="grid grid-cols-5 gap-3 sm:flex sm:flex-wrap">
        {ROUTE_COLORS.map((c) => {
          const isSelected = c.value === value
          return (
            <button
              key={c.value}
              type="button"
              title={c.label}
              aria-label={c.label}
              aria-pressed={isSelected}
              onClick={() => onChange(c.value)}
              className={`flex aspect-square w-full items-center justify-center rounded-full transition-transform active:scale-95 sm:h-9 sm:w-9 sm:hover:scale-110 ${
                // A white swatch needs an outline to be seen on the white sheet.
                isLightColor(c.value) ? 'border border-foreground/20' : ''
              } ${isSelected ? 'ring-2 ring-foreground/70 ring-offset-2 ring-offset-content1' : ''}`}
              style={{ backgroundColor: c.value }}
            >
              {isSelected && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={getContrastTextColor(c.value)}
                  strokeWidth={3}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-4 w-4"
                  aria-hidden
                >
                  <path d="M5 12l5 5L20 7" />
                </svg>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
